import { Typography } from "@mui/material";
import React from "react";

function TitleIndustry({ children, color }) {
  return (
    <Typography
      sx={{
        fontSize: ["1.8rem", "1.7rem", "2rem","1.8rem", "2.4rem"],
        color: color ?? "#00B4D8",
        fontFamily: "fascinate-inline",
        fontWeight: "bold",
      }}
    >
      {children}
    </Typography>
  );
}

export default TitleIndustry;
